<div [class]="containerClass">
  <!--Underline style-->
  <div *ngIf="type === 'underline'" id="tabs-title" class="flex">
    <div *ngFor="let tab of tabs" (click)="setActiveTab(tab)" [class]="'text-center mr-7 cursor-pointer '+ titleClass + ' ' + (tab.active ? activeTitleClass : '')"
      [ngClass]="{ 'border-b-2  font-semibold': tab.active }"
      [ngStyle]="{ 'border-color': getColor(), color: getColor() }">
      {{ tab.title }}
    </div>
  </div>
  <!--Chips style-->
  <div *ngIf="type === 'chips'" id="tabs-title"
    class="flex gap-x-[18px] overflow-x-auto px-4 py-3.5 shadow-lg aspect43:shadow-none bg-white">
    <div *ngFor="let tab of tabs" (click)="setActiveTab(tab)"
      [class]="'cursor-pointer text-center px-3.5 flex h-8 items-center whitespace-nowrap '+ titleClass + ' ' + (tab.active ? activeTitleClass : '')" [ngClass]="{
        '!bg-opacity-30 rounded-2xl': tab.active
      }" [style.background-color]="tab.active ? getColor() : 'transparent'"
      [style.color]="tab.active ? 'white' : getColor()">
      {{ tab.title }}
    </div>
  </div>
  <div>
    <ng-content></ng-content>
  </div>
</div>